// extracted by mini-css-extract-plugin
export default {"background":"background___MGir5","highContrastOutline":"highContrastOutline___TzoLM"};